import { IAgendaCorporativo } from "../agenda_corporativo";
import { Cliente } from "../cliente.interface";
import { IOrdenServicioCorporativo } from "../orden_servicio_corporativo";
import { IPreventaCorporativo } from "../preventa/preventa_corporativo.interface";
import { IProspectoCorporativo } from "../prospecto/prospecto_corporativo.interface";
import { IFactibilidadCorporativo } from "./factibilidad_corporativo.interface";

export interface ITrazoCorporativo{
  id_trazo_corporativo?: string;
  estado: boolean;
  codigo: string;
  numero_referencia: string;
  accion: string;
  detalles?: string;
  rol_usuario?: string;
  tipo_empleado: string;
  ip: string;
  user: string;
  empleado: string;
  cargo: string;
  prospecto_corporativo: string;
  preventa_corporativa: string;
  agendamiento_corporativo: string;
  orden_servicio_corporativo: string;
  codigo_otp: string;
  cliente: string;
  factibilidad_corporativa: string;
  fecha_creacion?: Date
  fecha_modificacion?: Date
}


export interface ITrazoCorporativoResp {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: ITrazoCorporativo[];
}

export type ITrazoCorporativoOverloaded = Partial<ITrazoCorporativo> & {
  prospecto_corporativo_data: IProspectoCorporativo
  preventa_corporativa_data: IPreventaCorporativo
  factibilidad_corporativa_data: IFactibilidadCorporativo
  agendamiento_corporativo_data: IAgendaCorporativo
  orden_servicio_corporativo_data: IOrdenServicioCorporativo
  cliente_data: Cliente 
}


export const UBICACION_EVA_VENTA_CORPORATIVA = {
  PROSPECTO_EN_ESPERA:"PROSPECTO EN ESPERA",
  PROSPECTO_FINALIZADO:"PROSPECTO FINALIZADO",
  PROSPECTO_FALLIDO:"PROSPECTO FALLIDO",

  PREVENTA_EN_ESPERA:"PREVENTA CREADA - PREFACTIBILIDAD EN ESPERA DE APROBACIÓN",
  PREFACTIBILIDAD_APROBADA:"PREFACTIBILIDAD APROBADA - COMPLETAR INFORMACIÓN",
  PREFACTIBILIDAD_LLENA:"CREANDO FACTIBILIDAD",
  
  FACTIBILIDAD_EN_INSPECCION:"FACTIBILIDAD EN INSPECCIÓN",
  FACTIBILIDAD_INSPECCIONADA:"FACTIBILIDAD INSPECCIONADA",
  FACTIBILIDAD_PENDIENTE:"FACTIBILIDAD PENDIENTE DE ENVÍO A INVENTARIO",
  
  FACTIBILIDAD_PREAPROBACION_INVENTARIO:"ESPERANDO PREAPROBACIÓN DE INVENTARIO",
  
  FACTIBILIDAD_PENDIENTE_SUPERVISOR:"INVENTARIO PREAPROBADA - EN REVISIÓN POR SUPERVISOR",
  FACTIBILIDAD_SOLICITA_DOCUMENTOS:"CARGA DE DOCUMENTOS SOLICITADA A VENDEDOR",
  FACTIBILIDAD_DOCUMENTOS_CARGADOS:"DOCUMENTOS CARGADOS POR VENDEDOR",
  FACTIBILIDAD_SOLICITA_CORRECCION:"CORRECCIÓN DE DOCUMENTOS SOLICITADA A VENDEDOR",
  FACTIBILIDAD_DOCUMENTOS_CORREGIDOS:"DOCUMENTOS CORREGIDOS - EN REVISIÓN POR SUPERVISOR",
  FACTIBILIDAD_CORREGIDA:"FACTIBILIDAD CORREGIDA",

  FACTIBILIDAD_SOLICITADA_APROBACION_FINAL:"FACTIBILIDAD ENVIADA PARA APROBACIÓN FINAL POR INVENTARIO",
  
  FACTIBILIDAD_ESPERA_AGENDAMIENTO:"FACTIBILIDAD EN ESPERA DE AGENDAMIENTO",

  AGENDAMIENTO_CREADO:"AGENDAMIENTO REALIZADO",
  AGENDAMIENTO_RECOORDINADO:"AGENDAMIENTO RECOORDINADO",

}